import styled from "styled-components";

export const TitleStyle = {
  height: "fit-content",
  width: "fit-content",
  fontWeight: 600,
  fontSize: "20px",
};

export const HeaderStyle = {
  height: "fit-content",
  width: "fit-content",
  fontWeight: 800,
  fontSize: "42px",
};

export const DescriptionStyle = {
  height: "fit-content",
  width: "fit-content",
  fontWeight: 400,
  fontSize: "20px",
  margin: "10px 0 0 0",
};

export const VotersBoardContainer = styled.div`
  // display: flex;
  // flex-direction: column;
  // width: 1400px;
  // min-height: 800px;
  // align-items: center;
  // border-radius: 10px;
  // background: #919aa4;
`;

export const HeadersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
  font-family: "Open Sans";
`;
